import { DataValveCDMEvent } from 'node_modules/@clientos/commons-northbound-api/dist/services/AnalyticsService/types';

/**
 * Creates a DataValveCDMEvent object with the provided event details.
 *
 * @param eventDetail - An object containing the details of the analytic event.
 * @returns A DataValveCDMEvent object populated with the current date/time, event type, category, provided details, and version.
 */
export function createAnalyticEvent(eventDetail: object): DataValveCDMEvent {
  return {
    dateTime: new Date().toISOString(),
    eventDetailType:
      'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1',
    eventCategory: 'simpleUi',
    eventDetail: eventDetail,
    version: '1.5.0'
  };
}
